import { IRestaurant } from '@/shared/model/restaurant.model';
import { IMarketer } from '@/shared/model/marketer.model';
import { ICustomer } from '@/shared/model/customer.model';

export interface IAddress {
  id?: number;
  street?: string | null;
  addressAddition?: string | null;
  number?: string | null;
  companyName?: string | null;
  department?: string | null;
  zipcode?: string | null;
  floor?: string | null;
  city?: string | null;
  phone?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  restaurant?: IRestaurant | null;
  marketer?: IMarketer | null;
  customer?: ICustomer | null;
}

export class Address implements IAddress {
  constructor(
    public id?: number,
    public street?: string | null,
    public addressAddition?: string | null,
    public number?: string | null,
    public companyName?: string | null,
    public department?: string | null,
    public zipcode?: string | null,
    public floor?: string | null,
    public city?: string | null,
    public phone?: string | null,
    public latitude?: number | null,
    public longitude?: number | null,
    public restaurant?: IRestaurant | null,
    public marketer?: IMarketer | null,
    public customer?: ICustomer | null,
  ) {}
}
